'use client'

import { ArrowLeft } from 'lucide-react'
import Link from 'next/link'
import { useParams } from 'next/navigation'

export const NotFoundHomeLink = () => {
  const params = useParams<{ network: string }>()
  const network = params?.network

  return (
    <Link
      href={network ? `/n/${network}/home` : '/'}
      className="flex animate-pulse items-center gap-2">
      <ArrowLeft size={16} aria-hidden /> Back to homepage
    </Link>
  )
}
